/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
const colors = {
    transparent: 'transparent',
    current: 'currentColor',
    white: '#FFFFFF',

    null: 'transparent',

    black: {
        10: '#F7F8FA',
        20: '#F0F1F2',
        30: '#E6E8EB',
        40: '#CBCDD1',
        50: '#B3B6BA',
        60: '#828489',
        70: '#595C61',
        80: '#36383C',
        90: '#17191B',
        100: '#000000',
    },

    'brand-primary': {
        60: '#828489',
        80: '#36383C',
        100: '#000000',
    },

    'brand-secondary': {
        60: '#B3D889',
        80: '#94C859',
        100: '#76B82A',
    },

    'brand-tertiary': {
        100: '#FF0000',
    },

    'brand-quaternary': {
        100: '#F59E33',
    },

    'brand-quinary': {
        100: '#007BC2',
    },

    danger: {
        60: '#FEF2F3',
        80: '#FFA2AB',
        100: '#DE1C2F',
    },

    success: {
        60: '#EAFEE7',
        80: '#6BF462',
        100: '#0F8A0F',
    },

    borderLight: '#E6E6E6',
    borderDark: '#000000',
    'border-inverse': '#FFFFFF',
    'brand-primary-opacity': 'rgba(0,0,0,.6)',
    imageBackground: 'rgba(0,0,0,.05)',
    overlayBackgroundModal: 'rgba(0, 0, 0, 0.75)',
    buttonShopDefault: '#76B82A',
}

export default colors
